import classNames from 'classnames';
import { ReactNode } from 'react';

import SectionTitle from '../typography/SectionTitle';

import styles from '../../styles/headers/index-default-header.module.css';

export interface IndexDefaultHeaderProps {
    title?: ReactNode;
    brand?: Brand;
    placeholder?: boolean;
    className?: string | null;
}

const IndexDefaultHeader = ({
    title = null,
    brand = null,
    placeholder = false,
    className = null,
}: IndexDefaultHeaderProps) => {
    const { handle: brandHandle = null } = brand || {};
    return (
        <div className={classNames([styles.container, className])} data-brand={brandHandle}>
            <div className={styles.bar}>
                <SectionTitle className={styles.title} placeholder={placeholder}>
                    {title}
                </SectionTitle>
            </div>
        </div>
    );
};

export default IndexDefaultHeader;
